import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import mutation from './updateServiceSettingMutation.graphql';

export function updateLocationServiceSetting(locationId, settings) {
    return async (dispatch, getState, { client }) => {
        dispatch(setLoaderStart('LocationServiceSetting'));

        const { data } = await client.mutate({
            mutation,
            variables: { locationId, ...settings },
        });

        dispatch(setLoaderComplete('LocationServiceSetting'));

        if (data?.updateLocationServiceSetting?.status === 200) {
            toastr.success('Success!', 'Service settings have been saved successfully.');
            return { status: 200 };
        } else {
            const msg = data?.updateLocationServiceSetting?.errorMessage;
            toastr.error('Error!', msg || 'Something went wrong. Please try again.');
            return { status: 400 };
        }
    };
}
